// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kpc-index-view{max-width:50em;margin-left:auto;margin-right:auto}.kpc-label{display:inline-block;margin-bottom:.5em;font-size:.75em;font-weight:400}.kpc-search{position:relative;max-width:24em;margin-left:auto;margin-right:auto}.kpc-search-button{position:absolute;top:50%;right:0;width:2em;height:2em;padding:0;text-align:center;border-radius:10em;transform:translateY(-50%)}.kpc-input{width:100%;padding-right:5em;border-radius:10em}.kpc-autocomplete-empty{white-space:normal}", ""]);
// Exports
module.exports = exports;
